import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react'
import { useBoolean, useList } from 'react-use'

const MapboxContext = createContext()
export default MapboxContext

export function useMapboxContext () {
  return useContext(MapboxContext)
}

export function useMapboxStates (lng, lat, zoom) {
  // map容器
  const mapContainer = useRef(null)
  // map对象
  const map = useRef(null)
  // 地图原始中心点
  const originMapCenter = useMemo(() => [lng, lat], [lng, lat])
  // 地图中心点
  const [mapCenter, setMapCenter] = useState([lng, lat])
  // 地图层级
  const [mapZoom, setMapZoom] = useState(zoom)
  // 地图边界
  const [mapBounds, setMapBounds] = useState()
  // 地图是否已加载完成
  const [mapLoaded, setMapLoaded] = useState(false)
  // 地图是否全屏
  const [fullScreen, toggleFullScreen] = useBoolean(false)
  // 当前地图上所有的school marker
  const [mapboxSchoolMarkers, {set: setMapboxSchoolMarkers, push: pushMapboxSchoolMarker, removeAt: removeAtMapboxSchoolMarker}] = useList([])
  // layer显示相关
  const [layerVisible, setLayerVisible] = useState({
    satelliteLinz: false,
    unitaryPlanZone: false,
    undergroundServices: false,
    floodAssessment: false,
    contour: false,
  })
  // Satellite layer
  const changeSatelliteLayerLinzVisible = useCallback(value => {
    setLayerVisible(d => ({ ...d, 'satelliteLinz': value }))
  }, [])
  // Unitary Plan Zone layer
  const changeUnitaryPlanZoneVisible = useCallback(value => {
    setLayerVisible(d => ({ ...d, 'unitaryPlanZone': value }))
  }, [])
  // Underground Services layer
  const changeUndergroundServicesVisible = useCallback(value => {
    setLayerVisible(d => ({ ...d, 'undergroundServices': value }))
  }, [])
  // Flood Assessment layer
  const changeFloodAssessmentVisible = useCallback(value => {
    setLayerVisible(d => ({ ...d, 'floodAssessment': value }))
  }, [])
  // Contours
  const changeContourAssessmentVisible = useCallback(value => {
    setLayerVisible(d => ({ ...d, 'contour': value }))
  }, [])

  return {
    mapContainer,
    map,
    originMapCenter,
    mapCenter,
    setMapCenter,
    mapZoom,
    setMapZoom,
    mapBounds,
    setMapBounds,
    mapLoaded,
    fullScreen,
    setMapLoaded,
    layerVisible,
    changeSatelliteLayerLinzVisible,
    changeUnitaryPlanZoneVisible,
    changeUndergroundServicesVisible,
    changeFloodAssessmentVisible,
    changeContourAssessmentVisible,
    mapboxSchoolMarkers,
    toggleFullScreen,
    setMapboxSchoolMarkers,
    pushMapboxSchoolMarker,
    removeAtMapboxSchoolMarker
  }
}